import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import './App.css';
import Home from './Home';
import About from './About';
import Products from './Products';
import Contact from './Contact';
import Distributor from './Distributor';
import Login from './Login';
import Dashboard from './Dashboard';
import Enquiries from './Enquiries';
import Distributorship from './Distributorship';
import Users from './Users';
import Viewproduct from './Viewproduct';
import Settings from './Settings';
import Page404 from './Page404';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/About' element={<About />}></Route>
        <Route path='/Products' element={<Products />}></Route>
        <Route path='/Viewproduct' element={<Viewproduct />}></Route>
        <Route path='/Contact' element={<Contact />}></Route>
        <Route path='/Distributor' element={<Distributor />}></Route>
        <Route path='/Login' element={<Login />}></Route>
        <Route path='/Dashboard' element={<Dashboard />}></Route>
        <Route path='/Enquiries' element={<Enquiries />}></Route>
        <Route path='/Distributorship' element={<Distributorship />}></Route>
        <Route path='/Users' element={<Users />}></Route>
        <Route path='/Settings' element={<Settings />}></Route>
        <Route path='*' element={<Page404 />}></Route>
      </Routes>
    </Router>
  );
}

export default App;